
import React from 'react';
import ResellerRevenueChart from '@/components/superadmin/reseller/ResellerRevenueChart';
import ActivePlansCard from '@/components/masterlicense/reseller/ActivePlansCard';
import { ActivePlan } from '@/hooks/license/useResellerPlanManagement';
import { RevenueHistoryItem } from '@/hooks/useResellerPlanData';
import { MasterLicenseSettingsProvider } from '@/contexts/MasterLicenseSettingsContext';

interface ResellerDataSectionProps {
  revenueHistory: RevenueHistoryItem[];
  activePlans: ActivePlan[];
  currentPlan: ActivePlan;
  onTogglePlanEnabled: (planId: string, enabled: boolean) => void;
}

const ResellerDataSection: React.FC<ResellerDataSectionProps> = ({
  revenueHistory,
  activePlans,
  currentPlan,
  onTogglePlanEnabled
}) => {
  return (
    <MasterLicenseSettingsProvider isLoading={false}>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
        <ResellerRevenueChart revenueHistory={revenueHistory} />
        <div className="lg:col-span-1">
          <ActivePlansCard 
            plans={activePlans} 
            currentPlan={currentPlan}
            onToggleEnabled={onTogglePlanEnabled}
            title="Active Reseller Plans"
            description="View and manage your active reseller plans"
          />
        </div>
      </div>
    </MasterLicenseSettingsProvider>
  );
};

export default ResellerDataSection;
